import { t } from 'i18next'
import { ToastEventPayload } from '~/hooks/toast/useToastAlerts'
import {
  NotificationDomain,
  NotificationPayload,
} from '~/services/EventEmitter/types/NotificationEmitterTypes'

export enum GeneralOperation {
  CopyLinkToClipboard = 'copyLinkToClipboard',
  GeneralCopyToClipboard = 'copyToClipboard',
  SwitchedExtension = 'switchedExtension',
  SwitchedPbx = 'switchedPbx',
}

const getCopiedLinkToClipboardEvent = (
  payload: NotificationPayload<NotificationDomain.GENERAL>,
) => {
  let title = ''
  let showToast = true

  switch (payload.disposition) {
    case 'green.solid':
      title = t('global.toast.copyLinkSuccess')
      break
    default: {
      showToast = false
      break
    }
  }

  if (!showToast) {
    return
  }

  return {
    title,
    disposition: payload.disposition,
    durationMs: 3250,
  } as ToastEventPayload
}

const getCopiedGeneralToClipboardEvent = (
  payload: NotificationPayload<NotificationDomain.GENERAL>,
) => {
  let title = ''
  let showToast = true

  switch (payload.disposition) {
    case 'green.solid':
      title = t('global.toast.copySuccess')
      break
    case 'red.solid':
      title = t('global.toast.copyError')
      break
    default: {
      showToast = false
      break
    }
  }

  if (!showToast) {
    return
  }

  return {
    title,
    disposition: payload.disposition,
    durationMs: 3250,
  } as ToastEventPayload
}

const getSwitchedExtensionEvent = (
  payload: NotificationPayload<NotificationDomain.GENERAL>,
) => {
  let title = ''
  let showToast = true

  switch (payload.disposition) {
    case 'green.solid':
      title = t('global.toast.extensionSwitched')
      break
    default: {
      showToast = false
      break
    }
  }

  if (!showToast) {
    return
  }

  return {
    title,
    description: payload.message,
    disposition: payload.disposition,
    durationMs: 3250,
  } as ToastEventPayload
}

const getSwitchedPbxEvent = (
  payload: NotificationPayload<NotificationDomain.GENERAL>,
) => {
  let title = ''
  let showToast = true

  switch (payload.disposition) {
    case 'green.solid':
      title = t('global.toast.pbxChanged')
      break
    default: {
      showToast = false
      break
    }
  }

  if (!showToast) {
    return
  }

  return {
    title,
    description: payload.message,
    disposition: payload.disposition,
    durationMs: 3250,
  } as ToastEventPayload
}

export const getGeneralToastEvent = (
  payload: NotificationPayload<NotificationDomain.GENERAL>,
) => {
  switch (payload.operation) {
    case GeneralOperation.CopyLinkToClipboard:
      return getCopiedLinkToClipboardEvent(payload)
    case GeneralOperation.GeneralCopyToClipboard:
      return getCopiedGeneralToClipboardEvent(payload)
    case GeneralOperation.SwitchedExtension:
      return getSwitchedExtensionEvent(payload)
    case GeneralOperation.SwitchedPbx:
      return getSwitchedPbxEvent(payload)
    default:
      return null
  }
}
